"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDetectionClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
const axios_1 = tslib_1.__importDefault(require("axios"));
class ChangeDetectionClient extends authenticated_client_1.AuthenticatedClient {
    detectChanges(changeDetectionRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `http://localhost:1337/proxy/v1/lcd_predict`;
            const response = yield axios_1.default.post(url, changeDetectionRequest);
            return response.data;
        });
    }
}
exports.ChangeDetectionClient = ChangeDetectionClient;
//# sourceMappingURL=change-detection.client.js.map